import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    url: String,
  };

  connect() {
    this.element.style.cursor = "pointer";
  }

  navigate(event) {
    console.log("Clickable row clicked");
    // Don't navigate if clicking on a link, button, or input
    const target = event.target;
    if (
      target.closest("a") ||
      target.closest("button") ||
      target.closest("input") ||
      target.closest(".dropdown")
    ) {
      return;
    }

    // Navigate to the URL
    window.location = this.urlValue;
  }
}
